import {ReclamationBill} from '../../../app/interfaces/bill';
import {SetFieldValue} from '../../../app/types/Forms';
import Select from '../../../app/common/components/select/Select';
import {useGetReclamationBills} from '../Hooks/TicketHooks';
import {useEffect} from "react";
import {useIntl} from 'react-intl';

interface SelectBillProps {
  name?: string;
  value?: ReclamationBill;
  setFieldValue: SetFieldValue;
  touched?: boolean;
  error?: string;
  defaultBillNumber?: string;
}

const SelectBill = ({
                      name,
                      value,
                      setFieldValue,
                      touched,
                      error,
                      defaultBillNumber,
                    }: SelectBillProps): JSX.Element => {
  const intl = useIntl();
  const {isLoading: isLoadingBills, data: bills} = useGetReclamationBills();

  useEffect(() => {
    if (bills) {
      const defaultVal = bills.find((search) => search.id === defaultBillNumber);
      if (defaultVal) {
        setFieldValue('bill', defaultVal);
      }
    }
  }, [bills, defaultBillNumber, setFieldValue]);

  return (
    <Select<ReclamationBill>
      label={intl.formatMessage({id: 'TICKET.SELECT.BILL'})}
      isDisabled={isLoadingBills}
      isLoading={isLoadingBills}
      isClearable={true}
      isSearchable={true}
      name={name}
      onChange={(bill) => {
        setFieldValue('bill', bill);
      }}
      value={value}
      getOptionValue={(bill) => bill.id}
      getOptionLabel={(bill) => bill.id}
      options={bills || []}
      placeholder={intl.formatMessage({id: 'TICKET.SELECT.BILL_PLACEHOLDER'})}
      touched={touched}
      error={error}
    />
  );
};

export default SelectBill;
